$( document ).ready(function() {

$( `input[name="Size"]` ).change(function() {
    var size = $(this).val();
    $('.productsize').html(`&nbsp;– ${size}`);
  });


  var quantityField = $('.pdpqtyinput');

  $('.button-minus').click(function(){
    if (quantityField.val() > 1) {
       quantityField.val(parseInt(quantityField.val(), 10) - 1);
    }
  });

  $('.button-plus').click(function(){
    quantityField.val(parseInt(quantityField.val(), 10) + 1);
  });


  $( ".subscribebtn" ).click(function( event ) {
    $('.subscriptionoptions').show();
    $('.subscribenowbtn').hide();
    $('.subscribebtn').addClass('subscriptionopen');
    $('.atcsubscribebtn').show();
    $('[data-add-to-cart-text]').hide();
    $('.paymentterms').hide();
    $('.onetimepurchaseswitch').css({
      "visibility": "visible",
      "pointer-events": "auto"
    });
    $('#selling_plan_subscription').prop("checked", true);
    
    // Update Add to Cart button with subscription price
    var subscriptionPrice = $('.subscriptionprice').first().text();
    if (subscriptionPrice) {
      $('[data-atc-price]').text(subscriptionPrice);
    }
  });
  
  
    $( ".onetimepurchaseswitch" ).click(function( event ) {
    $('.subscriptionoptions').hide();
    $('.subscribenowbtn').show();
    $('.subscribebtn').removeClass('subscriptionopen');
    $('.atcsubscribebtn').hide();
    $('[data-add-to-cart-text]').show();
    $('.paymentterms').show();
    $('.onetimepurchaseswitch').css({
      "visibility": "hidden",
      "pointer-events": "none"
    });
    $('#selling_plan_onetime').prop("checked", true);
    
    // Restore original product price in Add to Cart button
    var originalPrice = $('[data-product-price]').first().text();
    if (originalPrice) {
      $('[data-atc-price]').text(originalPrice.trim());
    }
  });
  
  
  
  $( ".deliveryoption" ).click(function( event ) {
	if (!($(this).hasClass("active"))) {
       $(".deliveryoption").removeClass('active');
      $(this).addClass('active');
    }
    var subscribeoption = $(this).data('val');
    $('.subscriptionselectioninput').val(subscribeoption);
    
    // Update Subscribe Now button price when delivery option changes
    var selectedPrice = $(this).find('.subscription-pricing').text() || $(this).text().split('•')[1];
    if (selectedPrice) {
      $('[data-subscribe-now-price]').text(selectedPrice.trim());
    }
  });
  
  
  



   var slidecount = ($(".product-main-slide").length - 1);
   var currentindex = $('.product-main-slide.is-selected').data('index');
   var nextslide;
   var prevslide;


  $( ".photonav" ).click(function( event ) {

    currentindex = $('.product-main-slide.is-selected').data('index');

    if ($(this).hasClass( "left" )) {

        if(currentindex > 0) {
            prevslide = currentindex - 1;
        }

        else {
            prevslide = slidecount;
        }

        $(`.dot[data-index="${prevslide}"]`).click();

        
    }

    else {


        if(currentindex === slidecount) {
            nextslide = 0;
        }
        else {
            nextslide = currentindex + 1;
        }

        $(`.dot[data-index="${nextslide}"]`).click();

    }

});
  
  
  const swiper = new Swiper('.saunaswiper', {
  
    loop: true,
    autoHeight: false,
    
      effect: 'fade',
  fadeEffect: {
    crossFade: true
  },

  pagination: {
    el: '.saunadots',
    clickable: true,
  },

  navigation: {
    nextEl: '.saunaswipenext',
    prevEl: '.saunaswipeprev',
  },

});
  
  
  
 $('.productdetailitem').click(function(e){

  var target = e.target;
  if($(target).prop('nodeName') != 'P' && $(target).prop('nodeName') != 'LI' && $(target).prop('nodeName') != 'A' && $(target).prop('nodeName') != 'UL' && $(target).prop('nodeName') != 'U') {
  if (!($(this).hasClass("expanded"))) {
    
    $(this).removeClass("minimized");
    $(this).addClass("expanded");
    
  }
   
   else {
     $(this).removeClass("expanded");
     $(this).addClass("minimized");
   }
   }
  });
  
  
  
  $('[data-section-type="product-recommendations"]').on( "submit", ".relatedproductform", function(e) {

   e.preventDefault();
   var variantid = $(this).data('variant');
    
    let formData = {
 'items': [{
  'id': variantid,
  'quantity': 1
  }]
};
    
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
  
  document.dispatchEvent(new CustomEvent('cart:build'));  
  document.dispatchEvent(new CustomEvent('cart:open'));  
  
})

    
    });
  

 
  
});


if ($('.productdetailitem').length > 4) {
  
$.getScript(masonryscript, function( data, textStatus, jqxhr ) {

var $details;

function masonrydetails () {
$details  = $('.productdetailsflex').masonry({
  itemSelector: '.productdetailitem',  
  percentPosition: true
});


$details.on( 'click', '.productdetailitem', function() {
  $details.masonry('layout');
});
}

if ($(window).width() > 1100) {
masonrydetails();
}

$(window).on('resize', function(){
    var windowwidth = $(this); 
    if (windowwidth.width() > 1100) { 
    masonrydetails();
    }
   else {
    if ($details) {
    $details.masonry('destroy');
    }
  }
});

});

  
}